import { useContext } from 'react';
import { useWatch } from 'react-hook-form';
import { CartContext } from '@/entities/cart';
import { VenueContext } from '@/features/venue-router';
import { haversineDistance } from '@/shared/lib/distance';

export const useVenueDistance = (): string | null => {
    const ctx = useContext(VenueContext);
    const { formMethods } = useContext(CartContext);
    const [cartLat, cartLon] = useWatch({
        control: formMethods?.control,
        name: ['deliveryMethod.address.lat', 'deliveryMethod.address.lon'],
    }) ?? [undefined, undefined];

    let distance = ctx?.data.distance;
    if (distance == null) {
        const venueLat = parseFloat(ctx?.data?.address?.lat ?? '');
        const venueLon = parseFloat(ctx?.data?.address?.lon ?? '');
        const aLat = parseFloat(cartLat ?? '');
        const aLon = parseFloat(cartLon ?? '');
        if (
            Number.isFinite(venueLat) &&
            Number.isFinite(venueLon) &&
            Number.isFinite(aLat) &&
            Number.isFinite(aLon)
        ) {
            distance = haversineDistance({ lat: aLat, lon: aLon }, { lat: venueLat, lon: venueLon });
        }
    }

    if (distance == null || !Number.isFinite(distance)) {
        return null;
    }
    return `${distance.toFixed(1)} km`;
};
